import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public mobileOpen: boolean = false;

    public async ngOnInit() {
        await this.service.init();
    }

    @HostListener('document:click')
    public clickout() {
        if (this.mobileOpen) {
            this.mobileOpen = false;
        }
    }

    public toggleMobile() {
        this.mobileOpen = !this.mobileOpen;
    }

    public async closeMobile() {
        this.mobileOpen = false;
        await this.service.render();
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0;
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[13px] font-medium bg-gray-100 text-emerald-700";
        }
        return "flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[13px] font-medium text-gray-600 hover:bg-gray-50 hover:text-emerald-600 transition-colors";
    }

    public mobileActiveClass(link: string) {
        if (this.isActive(link)) {
            return "flex items-center gap-2 px-3 py-2 rounded-md text-[13px] font-medium bg-emerald-50 text-emerald-700";
        }
        return "flex items-center gap-2 px-3 py-2 rounded-md text-[13px] font-medium text-gray-600 hover:bg-gray-50";
    }

    public printPage() {
        const originalTitle = document.title;
        document.title = 'CGM분석보고서';
        window.print();
        document.title = originalTitle;
    }
}

export default ComponentNavSidebarComponent;